var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('object',{staticClass:"sd-equalizer",style:({ '--bar-color': _vm.barColor })},_vm._l((5),function(n){return _c('span',{key:n})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }